import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { PageWrapper } from '../components/layout/PageWrapper';
import { Seo } from '../components/Seo';
import { useAuthStore } from '../store/authStore';
import { isFreeAdmin } from '../lib/freeAdmins';

const SOCIAL_LINKS = [
  {
    name: 'YouTube',
    url: 'https://youtube.com/@queenslandmafiaclub',
    icon: '▶',
    color: 'border-red-600',
    desc: 'Записи игр и обзоры',
  },
  {
    name: 'Instagram',
    url: 'https://www.instagram.com/queenslandmafiaclub',
    icon: '📷',
    color: 'border-pink-500',
    desc: 'Фото и анонсы игр',
  },
];

const AUS_CLUBS = [
  { name: 'Mafia Melbourne', url: 'https://t.me/MelbourneMafiaClub', city: 'Мельбурн' },
  { name: 'Sydney Mafia Club', url: 'https://t.me/primetimechat', city: 'Сидней' },
];

export function LinksPage() {
  const { t } = useTranslation('common');
  const { user } = useAuthStore();

  return (
    <PageWrapper>
      <Seo title="Ссылки" description="YouTube, Instagram и другие ресурсы Queensland Mafia Club." path="/links" />
      <h1 className="text-4xl font-bold text-white mb-8">{t('links.title')}</h1>

      <section className="mb-12">
        <h2 className="text-xl font-semibold text-white mb-4">{t('links.social')}</h2>
        <div className="grid sm:grid-cols-2 gap-4">
          {SOCIAL_LINKS.map((link) => (
            <a
              key={link.name}
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              className={`bg-mafia-card border-2 ${link.color} rounded-xl p-6 hover:opacity-90 transition-opacity flex items-start gap-4`}
            >
              <span className="text-3xl">{link.icon}</span>
              <div>
                <h3 className="text-white font-semibold">{link.name}</h3>
                <p className="text-gray-400 text-sm">{link.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </section>

      <section>
        <h2 className="text-xl font-semibold text-white mb-4">{t('links.ausClubs')}</h2>
        <div className="space-y-3">
          {AUS_CLUBS.map((club) => (
            <a
              key={club.name}
              href={club.url}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-mafia-card border border-gray-700 rounded-xl p-5 flex items-center justify-between hover:border-gray-500 transition-colors block"
            >
              <div>
                <h3 className="text-white font-medium">{club.name}</h3>
                <p className="text-gray-500 text-sm">{club.city}</p>
              </div>
              <span className="text-gray-500">→</span>
            </a>
          ))}
        </div>
      </section>

      {isFreeAdmin(user?.email) && (
        <section className="mt-12">
          <h2 className="text-xl font-semibold text-white mb-4">Управление</h2>
          <Link
            to="/admin/finance"
            className="bg-mafia-card border border-mafia-border rounded-xl p-5 flex items-center justify-between hover:border-mafia-gold/50 transition-colors block"
          >
            <div>
              <h3 className="text-mafia-paper font-medium">Финансы</h3>
              <p className="text-mafia-muted text-sm">Учёт доходов, расходов и балансов клуба</p>
            </div>
            <span className="text-mafia-muted">→</span>
          </Link>
        </section>
      )}
    </PageWrapper>
  );
}
